import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Button from '../Button/Button';
import stepAgreementSelector from './stepAgreementSelector';

import './StepAgreement.pcss';

import { showApproveModal } from '../../store/step/actions';
import submitAppeal from '../../store/appealDataRequest/actions';

const StepAgreement = ({
  agreementOn,
  currentExam,
  onShowApproveModal,
  onSubmitAppeal,
  show,
  loading
}) => {
  if (!show) {
    return null;
  }

  const onSubmit =
    currentExam && currentExam.type_is_gve
      ? () => onSubmitAppeal()
      : () => onShowApproveModal();

  return (
    <div className="StepAgreement">
      <div className="StepAgreement__Button">
        <Button
          disabled={!agreementOn}
          primary
          progress={loading || undefined}
          onClick={onSubmit}
        >
          Подать апелляцию
        </Button>
      </div>
    </div>
  );
};

StepAgreement.propTypes = {
  agreementOn: PropTypes.bool.isRequired,
  show: PropTypes.bool.isRequired,
  onShowApproveModal: PropTypes.func.isRequired,
  onSubmitAppeal: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
};

export default connect(
  stepAgreementSelector,
  dispatch =>
    bindActionCreators(
      {
        onShowApproveModal: showApproveModal,
        onSubmitAppeal: submitAppeal
      },
      dispatch
    )
)(StepAgreement);
